import { createContext } from "react"

const HomeStepsContext = createContext({})

export default HomeStepsContext
